import { Box, Anchor, Text } from "grommet";
import { Tooltip } from "@material-ui/core";
import OfflineBoltIcon from "@material-ui/icons/OfflineBolt";
import WarningIcon from "@material-ui/icons/Warning";
import { ReactComponent as Logo } from "../../assets/umc-utrecht-logo.svg";

export function HeaderArea(): React.ReactElement {
  return (
    <Box gridArea="header" fill="horizontal" pad={{ vertical: "small" }} direction="row" justify="between" align="center">
      <Box width="189px" align="start">
        <Logo width="150" height="80" />
      </Box>
      <Box>
        <Text textAlign="end">
          Made by{" "}
          <Anchor href="https://www.linkedin.com/in/rutger-v-9846b8173/" target="_blank">
            Rutger van de Leur
          </Anchor>{" "}
          <br />
          &amp;{" "}
          <Anchor href="http://linkedin.com/in/max-bos/" target="_blank">
            Max Bos
          </Anchor>
        </Text>
      </Box>
    </Box>
  );
}
